import styled from 'styled-components';

import { SearchCard } from '../style';

export const StyledActorCard = styled(SearchCard)`
  .deathday {
    margin: 0;
    margin-top: 15px;
    font-weight: bold;
  }
`;
